var _module_exports = "\n\n<span ng-transclude ng-click=\"$ctrl.toggle()\"></span>";
var path = '/var/www/rezflow/client/assets/scripts/modules/reservations/bulk/template.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngtemplate-loader!./client/assets/scripts/modules/reservations/bulk/template.tpl.html
// module id = 312
// module chunks = 1